import {connect} from 'react-redux'

import type {State} from '../../../../reducers/types'
import {getOverviewHref} from '../../../../routes'
import {getBuild, getBuildStatusType, getIsSakuraUI} from '../../../../selectors'
import {resolveWebEntityLink} from '../../../../utils/entityLinks'

import BuildStatusLink from './BuildStatusLink'
import type {OwnProps, StateProps} from './BuildStatusLink.types'

const mapStateToProps = (state: State, {buildId}: OwnProps): StateProps => {
  const isSakuraUI = getIsSakuraUI(state)
  const build = getBuild(state, buildId)
  const {statusText, waitReason, startEstimate, number, queuePosition} = build || {}
  const link = isSakuraUI
    ? getOverviewHref({
        buildId,
        buildTypeId: build?.buildType,
      })
    : resolveWebEntityLink(build)
  return {
    statusType: getBuildStatusType(state, buildId),
    isSakuraUI: getIsSakuraUI(state),
    buildUrl: link || '',
    statusText,
    number,
    isQueued: build?.state === 'queued',
    queuePosition,
    waitReason,
    startEstimate,
  }
}

export default connect(mapStateToProps)(BuildStatusLink)
